import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ExperimentsPage } from '@/features/ml/experiments/experiments-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Liste des expériences d'un projet (porting README #79). */
export const Route = createFileRoute('/$tenant/projects/$projectId/experiments/')({
  component: ExperimentsRoute,
});

function ExperimentsRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="experiments"
      crumbs={[{ label: t('nav.items.experiments') }]}
    >
      <ExperimentsPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
